export const BASE_CDN_URL = window.location.hostname === 'discovery.brikl.io' ? 'https://cdn.discovery.brikl.io' : 'https://staging.cdn.discovery.brikl.io'    
export const APP_URL = window.location.hostname === 'discovery.brikl.io' ? 
  'https://app.brikl.io' : 
  window.location.hostname === 'staging.discovery.brikl.io' ? 'https://staging.app.brikl.io' : 'http://localhost:8080'



// WEBPACK FOOTER //
// ./src/helper/constants.js